export default function HowItWorks() {
  const steps = [
    {
      step: "01",
      icon: "ri-search-line",
      title: "Browse Structured Spreadsheet Categories",
      description: "Start by exploring our 14 organized product categories. Each itaobuyspreadsheet category contains curated listings from the main shopping database.",
    },
    {
      step: "02",
      icon: "ri-bar-chart-grouped-line",
      title: "Compare Products Using Built-in Tables",
      description: "Use the intuitive comparison tables to evaluate products side by side. Filter by price range, quality indicators, and popularity metrics effortlessly.",
    },
    {
      step: "03",
      icon: "ri-filter-3-line",
      title: "Filter by Price, Quality, and Popularity",
      description: "Apply smart filters to narrow down your choices. The itaobuy sheet system helps you zero in on exactly what matches your preferences.",
    },
    {
      step: "04",
      icon: "ri-external-link-line",
      title: "Click Through to Full Product Sources",
      description: "Once you have identified the best match, follow the direct link to access complete product details on the main platform.",
    },
    {
      step: "05",
      icon: "ri-shopping-bag-3-line",
      title: "Redirect to Main Platform for Final Access",
      description: "Complete your shopping journey on kaspreadsheet.com, where the full itaobuyspreadsheet database awaits with real-time updates.",
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-secondary-300/60 text-xs font-label text-foreground-600 tracking-wider uppercase whitespace-nowrap">
            How It Works
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-5xl font-bold text-foreground-950">
            How <span className="italic">itaobuyspreadsheet</span><br />
            Works for You
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 font-label max-w-[520px] mx-auto">
            Five simple steps from browsing to buying — designed for maximum efficiency.
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-1/2 left-[8%] right-[8%] h-[2px] bg-secondary-200 -translate-y-1/2"></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 md:gap-4 relative">
            {steps.map((item, index) => (
              <div key={item.step} className="relative flex flex-col items-center text-center group">
                <div className="relative z-10 w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-primary-500 text-background-50 mb-5 group-hover:bg-primary-600 transition-colors">
                  <span className="font-heading text-2xl md:text-3xl font-bold">{item.step}</span>
                </div>
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 text-primary-600 mb-4 group-hover:bg-primary-100/70 transition-colors">
                  <i className={`${item.icon} text-lg`}></i>
                </span>
                <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed font-label">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}